export default class ServiceModel {
    constructor({ id, name, description, language, icon, is_active, created_by_name }) {
        this.id = id;
        this.name_service = name;
        this.deskripsi = description;
        this.language = language;
        this.icon = icon;
        this.created_by_name = created_by_name;
        this.status = is_active;
    }
}